import React from 'react';

export default function HeaderArea() {
    return (
        <div className="headerArea">
            <h1 className="title">READY TO TRANSPORT YOUR CARGO</h1>
        </div>
    )
}
